// components/Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

export default function Footer() {
    const { t } = useTranslation();

    return (
        <footer className="bg-[#1c3a71] text-white py-2 mt-6">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row justify-between items-center">
                <p className="text-sm text-center md:text-left">
                    {t('allRightsReserved')} &copy; {new Date().getFullYear()} {t('appName')}
                </p>
                <div className="mt-4 md:mt-0 flex gap-x-6">
                    <ul className="flex justify-center mb-4 md:mb-0">
                        <li className="ml-4">
                            <a href="https://www.facebook.com/abdo.transportation.co/" target="_blank" rel="noreferrer"
                                className="rounded-full flex justify-center bg-white h-8 text-blue-900  w-8  mx-1 text-center pt-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    className='fill-current font-black hover:animate-pulse'>
                                    <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z">
                                    </path></svg>
                            </a>
                        </li>
                    </ul>
                    {/* <NavLink to="/" className="text-gray-400 hover:text-white text-sm">{t("home")}</NavLink>
                    <NavLink to="/About" className="text-gray-400 hover:text-white text-sm">{t("aboutUs")}</NavLink>
                    <NavLink to="/Services" className="text-gray-400 hover:text-white text-sm">{t("services")}</NavLink>
                    <NavLink to="/Contact" className="text-gray-400 hover:text-white text-sm">{t("contactUs")}</NavLink> */}
                </div>
            </div>
        </footer>
    );
}
